module.exports = __webpack_public_path__ + "images/emoji/fire_engine.195418f82917419e0f36.png";